import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IExceldenSepeteEkleModal_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IExceldenSepeteEkleModal_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetMusteriMarka: any[];
  GetMusteriMarka_dummy: any[];
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetExcelVeri: any[];
  GetExcelVeri_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  SiparisSepetInsert: number;
  SiparisSepetInsert_dummy: number;
  ForEach4: GetExcelVeri;
  ForEach4_dummy: GetExcelVeri;
  DeleteUserExcelVerileri: number;
  DeleteUserExcelVerileri_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  TeklifSepetiInsert: number;
  TeklifSepetiInsert_dummy: number;
  ForEach5: GetExcelVeri;
  ForEach5_dummy: GetExcelVeri;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp186460Visible: "visible" | "hidden";
  isComp475254Visible: "visible" | "hidden";
}

export class ExceldenSepeteEkleModal_ScreenBase extends React.PureComponent<
  IExceldenSepeteEkleModal_ScreenProps,
  any
> {
  exceldensepeteeklemodal_340651_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "SAVE",
          TagName: "Button1_label",
        },
        {
          Id: 373749,
          PropertyName: "value",
          Value: "CHOOSE BRAND",
          TagName: "Label3_value",
        },
        {
          Id: 561892,
          PropertyName: "value",
          Value: "ADD TO CART",
          TagName: "Label17_0_value",
        },
        {
          Id: 981503,
          PropertyName: "value",
          Value: "CHOOSE BRAND TO ADD CART",
          TagName: "Label20_value",
        },
        {
          Id: 61730704,
          PropertyName: "73c58b15-7dd2-ceb7-d915-e7e5549f399a_notify",
          Value: "SUCCESSFULLY COMPLETED",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 16351380,
          PropertyName: "388b366b-8c09-2153-54b2-9845ca04a075_notify",
          Value: "PRODUCTS ADDED TO OFFER CART",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Enregistrer",
          TagName: "Button1_label",
        },
        {
          Id: 373749,
          PropertyName: "value",
          Value: "Sélection de la marque",
          TagName: "Label3_value",
        },
        {
          Id: 561892,
          PropertyName: "value",
          Value: "Ajouter au panier",
          TagName: "Label17_0_value",
        },
        {
          Id: 981503,
          PropertyName: "value",
          Value: "Vous pouvez ajouter au panier en sélectionnant la marque",
          TagName: "Label20_value",
        },
        {
          Id: 44883395,
          PropertyName: "73c58b15-7dd2-ceb7-d915-e7e5549f399a_notify",
          Value: "Opération réalisée avec succès",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 16245187,
          PropertyName: "388b366b-8c09-2153-54b2-9845ca04a075_notify",
          Value: "Produits ajoutés au panier d’offre",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 64155,
          PropertyName: "label",
          Value: "Guardar",
          TagName: "Button1_label",
        },
        {
          Id: 373749,
          PropertyName: "value",
          Value: "Selección de marca",
          TagName: "Label3_value",
        },
        {
          Id: 340651,
          PropertyName: "placeholder",
          Value: "Añadir al carrito",
          TagName: "SelectBox1_placeholder",
        },
        {
          Id: 561892,
          PropertyName: "value",
          Value: "Añadir productos a la carrito seleccionando la marca",
          TagName: "Label17_0_value",
        },
        {
          Id: 981503,
          PropertyName: "value",
          Value: "La operación se ha realizado correctamente",
          TagName: "Label20_value",
        },
        {
          Id: 19930345,
          PropertyName: "73c58b15-7dd2-ceb7-d915-e7e5549f399a_notify",
          Value: "La operación se ha realizado correctamente",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 27772352,
          PropertyName: "388b366b-8c09-2153-54b2-9845ca04a075_notify",
          Value: "Los productos se han añadido a la carrito",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "9582f87f-baa2-4242-af5d-ce2d03442f3f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 561892, PropertyName: "value", Value: "Sepete Ekle" },
        {
          Id: 981503,
          PropertyName: "value",
          Value: "Marka Seçerek Sepete Ekleyebilirsiniz",
        },
        { Id: 373749, PropertyName: "value", Value: "Marka Seçimi" },
        { Id: 64155, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.exceldensepeteeklemodal_340651_value_kuikaAutoCompleteRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetParametreler: [],
      GetMusteriMarka: [],
      GetLanguage: "",
      GetExcelVeri: [],
      GoBack: "",
      IfThenElse: false,
      isComp186460Visible: "hidden",
      isComp475254Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("exceldensepeteeklemodal", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.ExceldenSepeteEkleModalPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("exceldensepeteeklemodal", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("exceldensepeteeklemodal", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ExceldenSepeteEkleModalPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      exceldensepeteeklemodal_340651_value:
        this.state.GetMusteriMarka?.at?.(0)?.cesit ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ExceldenSepeteEkleModalPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      cariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp186460Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetMusteriMarka = result?.data.getMusteriMarka;

    formVars.exceldensepeteeklemodal_340651_value =
      stateVars.GetMusteriMarka !== undefined
        ? stateVars.GetMusteriMarka?.length > 0
          ? stateVars.GetMusteriMarka[0].cesit
          : null
        : this.state.GetMusteriMarka?.length > 0
        ? this.state.GetMusteriMarka[0].cesit
        : null;
    formVars.exceldensepeteeklemodal_340651_options = stateVars.GetMusteriMarka;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExceldenSepeteEkleModalPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExceldenSepeteEkleModalPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      FiyatGrubu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.FiyatGrubu ??
          this.props.screenInputs.fiyatgrubu,
        "string"
      ),
      ListeFiyat_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ListeGrubu ??
          this.props.screenInputs.listegrubu,
        "string"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      Dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetExcelVeri = result?.data.getExcelVeri;
    stateVars.isComp475254Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetExcelVeri !== undefined
            ? stateVars.GetExcelVeri?.length > 0
              ? stateVars.GetExcelVeri[0].tumFiyatlarVarMi
              : null
            : this.state.GetExcelVeri?.length > 0
            ? this.state.GetExcelVeri[0].tumFiyatlarVarMi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ExceldenSepeteEkleModalPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.exceldensepeteeklemodal_340651_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetMusteriMarka !== undefined
          ? stateVars.GetMusteriMarka?.length > 0
            ? stateVars.GetMusteriMarka[0].cesit
            : null
          : this.state.GetMusteriMarka?.length > 0
          ? this.state.GetMusteriMarka[0].cesit
          : null
      );

    formVars.exceldensepeteeklemodal_340651_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.GetMusteriMarka !== undefined
          ? stateVars.GetMusteriMarka?.length > 0
            ? stateVars.GetMusteriMarka[0].cesit
            : null
          : this.state.GetMusteriMarka?.length > 0
          ? this.state.GetMusteriMarka[0].cesit
          : null
      );

    stateVars.dataSource_340651 =
      stateVars.GetMusteriMarka ?? this.state.GetMusteriMarka;
    stateVars.dataSource_340651 =
      stateVars.GetMusteriMarka ?? this.state.GetMusteriMarka;
    stateVars.isComp186460Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp475254Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetExcelVeri !== undefined
            ? stateVars.GetExcelVeri?.length > 0
              ? stateVars.GetExcelVeri[0].tumFiyatlarVarMi
              : null
            : this.state.GetExcelVeri?.length > 0
            ? this.state.GetExcelVeri[0].tumFiyatlarVarMi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_266090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_64155_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_if01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_if0each1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "exceldensepeteeklemodal_340651_value",
          "value",
          "GetMusteriMarka",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "exceldensepeteeklemodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.miktar),
        "number"
      ),
      BirimFiat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.fiyat),
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.stokKodu),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "exceldensepeteeklemodal_340651_value",
            "value",
            "GetMusteriMarka",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.isPlasiyer ??
          this.props.screenInputs.isplasiyer,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.kdV_ORANI),
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.stokAdi),
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.kod),
        "string"
      ),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.not1),
        "string"
      ),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.not2),
        "string"
      ),
      KalemNot_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalComponent_64155_onClick_if0each1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SiparisSepetInsert = result?.data.siparisSepetInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_64155_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetExcelVeri)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetExcelVeri
      )) {
        this.ForEach4 = item;
        await this.ExceldenSepeteEkleModalComponent_64155_onClick_if0each1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_if02_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_if02_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalComponent_64155_onClick_if02_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteUserExcelVerileri = result?.data.deleteUserExcelVerileri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_if03_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_if03_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "73c58b15_7dd2_ceb7_d915_e7e5549f399a_notify",
        this.defaultML,
        "İşlem Başarıyla Gerçekleşti"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ExceldenSepeteEkleModal",
      "SiparisOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_64155_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_else01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_else0each1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "exceldensepeteeklemodal_340651_value",
          "value",
          "GetMusteriMarka",
          "cesit",
          ""
        ),
        null
      ),
      message: "Bu Alan Boş Bırakılamaz",
      formName: "exceldensepeteeklemodal_340651_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.fiyat),
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KulID ?? this.props.screenInputs.kulid,
        "number"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.stokKodu),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "exceldensepeteeklemodal_340651_value",
            "value",
            "GetMusteriMarka",
            "cesit",
            "cesit"
          )
        ),
        "string"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.miktar),
        "number"
      ),
      PlasiyerMi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.isPlasiyer ??
          this.props.screenInputs.isplasiyer,
        "boolean"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.kdV_ORANI),
        "number"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.cariKod ?? this.props.screenInputs.carikod,
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.stokAdi),
        "string"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.kod),
        "string"
      ),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.not1),
        "string"
      ),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach5?.not2),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalComponent_64155_onClick_else0each1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiInsert = result?.data.teklifSepetiInsert;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_64155_onClick_else01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetExcelVeri)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetExcelVeri
      )) {
        this.ForEach5 = item;
        await this.ExceldenSepeteEkleModalComponent_64155_onClick_else0each1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_else02_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_else02_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ExceldenSepeteEkleModal/ExceldenSepeteEkleModalComponent_64155_onClick_else02_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteUserExcelVerileri = result?.data.deleteUserExcelVerileri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ExceldenSepeteEkleModalComponent_64155_onClick_else03_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ExceldenSepeteEkleModalComponent_64155_onClick_else03_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "388b366b_8c09_2153_54b2_9845ca04a075_notify",
        this.defaultML,
        "Ürünler Teklif Sepetine Eklendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ExceldenSepeteEkleModal",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  ExceldenSepeteEkleModalComponent_64155_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "exceldensepeteeklemodal_360255_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "1"
      )
    ) {
      isErrorOccurred =
        await this.ExceldenSepeteEkleModalComponent_64155_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.ExceldenSepeteEkleModalComponent_64155_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ExceldenSepeteEkleModalPageInit();
    }
  }
}
